import React, { useState, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  ActionsImageEs,
  ActionsImageWebpEs,
  ActionsImage,
  ActionsImageWebp,
} from '../../../assets/images/imageRepository';

const useGetActionsContent = () => {
  const intl = useIntl();
  const [actionImages, setActionImages] = useState(ActionsImage);
  const [actionImagesWebp, setActionImagesWebp] = useState(ActionsImageWebp);
  useEffect(() => {
    if (intl.locale === 'es') {
      setActionImages(ActionsImageEs);
      setActionImagesWebp(ActionsImageWebpEs);
    }
  }, [intl]);
  const ActionsContent = [
    {
      key: 'publishStories',
      images: actionImages.publishStories,
      imagesWebp: actionImagesWebp.publishStories,
      title: (
        <FormattedMessage
          id="landing.instagram.action1.title"
          defaultMessage="<s>Schedule</s> and publish your stories in seconds"
          values={{
            s: (...chunks) => (<strong>{chunks}</strong>),
          }}
        />
      ),
      description: (
        <FormattedMessage
          id="landing.instagram.action1.description"
          defaultImage="Only in Social Piper you can schedule or publish immediately to your Business Instagram Stories."
        />
      ),
    },
    {
      key: 'publishSimultaneous',
      images: actionImages.publishSimultaneous,
      imagesWebp: actionImagesWebp.publishSimultaneous,
      title: (
        <FormattedMessage
          id="landing.instagram.action2.title"
          defaultMessage="Publish <s>at the same time</s> to the rest of your social media Business profiles"
          values={{
            s: (...chunks) => (<strong>{chunks}</strong>),
          }}
        />
      ),
      description: (
        <FormattedMessage
          id="landing.instagram.action2.description"
          defaultImage="Forget about publishing your content to each platform. With Social Piper, you can post your stories, images, and videos to all your business social profiles IN ONE CLICK simultaneously."
        />
      ),
    },
    {
      key: 'recommendations',
      images: actionImages.recommendations,
      imagesWebp: actionImagesWebp.recommendations,
      title: (
        <FormattedMessage
          id="landing.instagram.action3.title"
          defaultMessage="Receive <s>recommendations</s> for the best times to post"
          values={{
            s: (...chunks) => (<strong>{chunks}</strong>),
          }}
        />
      ),
      description: (
        <FormattedMessage
          id="landing.instagram.action3.description"
          defaultImage="With our AI, Piper, you can see the best times and days to post on your social media business platforms, allowing you to reach more people and potential customers."
        />
      ),
    },
    {
      key: 'publishVideosImages',
      images: actionImages.publishVideosImages,
      imagesWebp: actionImagesWebp.publishVideosImages,
      title: (
        <FormattedMessage
          id="landing.instagram.action4.title"
          defaultMessage="Publish <s>optimized</s> videos or images on your Instagram Business Profile"
          values={{
            s: (...chunks) => (<strong>{chunks}</strong>),
          }}
        />
      ),
      description: (
        <FormattedMessage
          id="landing.instagram.action4.description"
          defaultImage="Through Social Piper, your videos or images will get optimized, so your clients can see your content faster."
        />
      ),
    },
    {
      key: 'addLogo',
      images: actionImages.addLogo,
      imagesWebp: actionImagesWebp.addLogo,
      title: (
        <FormattedMessage
          id="landing.instagram.action5.title"
          defaultMessage="<s>Add</s> your brand or logo to your posts easily"
          values={{
            s: (...chunks) => (<strong>{chunks}</strong>),
          }}
        />
      ),
      description: (
        <FormattedMessage
          id="landing.instagram.action5.description"
          defaultImage="Don’t worry about uploading your logo every time; With Social Piper, you can easily add it to your posts with a single click."
        />
      ),
    },
  ];

  return ActionsContent;
};

export default useGetActionsContent;
